import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import checkmarkImg from "../images/checkmark.b8187469.svg"
import arrowForwardImg from "../images/arrow-forward.svg"
import {Link} from "react-router-dom"; 
import $ from 'jquery';
import moment from 'moment';
import { secUser,guidance, database } from '../firebase'
export default class AssesmentApply5 extends Component {


  render() {

    return (

      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
          <div className="main-content" style={{background: "#f4f6f9" }}>    
            <div className="container p-0 pt-5">
              <div className='row'>
                <div className='col-lg-6 m-auto p-0'>
                  <form className='form-main-wrapper'>
                    <div className='form-group progress-det'>
                    <div className="form-group subhead">Answer the following psychometric questions</div>
                      {/* <span className='progress-content'>Step 5/5 : Psychometric</span>
                      <div className="progress">
                        <div className="progress-bar" role="progressbar" style={{width:"60%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                      </div> */}
                    </div>
                    <hr></hr>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Psychometric Question 1?</label>
                      <div className='row'>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="Yes"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>Yes</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="No"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>No</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Psychometric Question 2?</label>
                      <select className="form-control">
                        <option value="">Please select....</option>
                      </select> 
                    </div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Psychometric Question 3?</label>
                      <div className='row'>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="Yes"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>Yes</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="No"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>No</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Psychometric Question 4?</label>
                      <div className='row'>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="Yes"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>Yes</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="No"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>No</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                      </div>
                    </div>
                    
                    <div className="form-group mt-4">
                    <Link to="/user-dashboard">
                      <button className="btn btn-theme w-100">
                        Submit
                      </button>
                      </Link>
                    </div>
                    
                    <div className="form-group">                        
                      <p>Anytime you want to skip this session and book an appointment with your career success manager, please do. </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/assesment-apply5.jsx